import tw, { styled } from 'twin.macro'

export const ScreenWrapper = styled.div`
  ${tw`flex flex-col px-8 max-w-[790px] mx-auto`}
`
